<template>
  <BAlert
    show
    variant="danger"
    class="d-flex"
  >
    <b-icon
      icon="exclamation-triangle"
      class="flex-grow-0 pe-3"
    />
    <div class="font-condensed">
      <slot />
      <div
        v-if="code"
        class="mt-3"
      >
        {{ translate('errorCode', labels, 'shared_CommonErrors') }} {{ code }}
      </div>
    </div>
  </BAlert>
</template>

<script setup lang="ts">
import {useCommon} from '@/composables/useCommon'

defineProps<{
  code?: number
}>()

const {labels, translate} = useCommon()
</script>
